import moment from 'moment-timezone'
import { SET_BID_FILTER, CLEAR_BIDS_FILTER, UPDATE_BIDS_FILTER } from '../actionTypes'

//TODO: may want to set this up with initial values
const initialState = {
    load_type: 'OPEN',
    bid_status: 'BID',
    bid_date_start: moment.tz('America/Chicago').format('MM/DD/YYYY'),
    bid_date_end: moment.tz('America/Chicago').format('MM/DD/YYYY'),
    user: null,
    live_bids: true
}

//TODO: may want to store this in local storage
export default (state = initialState, action) => {
    switch (action.type) {
        case SET_BID_FILTER:
            return action.filter || initialState
        case UPDATE_BIDS_FILTER:
            return {...state, ...action.filter}
        case CLEAR_BIDS_FILTER:
            return initialState
        default:
            return state
    }
}